import { render } from "./editsupplier.vue?vue&type=template&id=21dc3720"
import script from "./editsupplier.vue?vue&type=script&lang=js"
export * from "./editsupplier.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__